import { Employee, EmployeeLocationType, Gender } from "../types/employees";

export type EmployeeFormValues = {
  fullName: string;
  nationalId: string;
  locationType: EmployeeLocationType | "";
  clientCompanyId: string;
  workstationId: string;
  email: string;
  phone: string;
  gender: Gender | "";
  department: string;
  jobTitle: string;
  seaYears: string;
  landline: string;
  nationality: string;
  note: string;
};

const trimOptional = (value: string) => {
  const trimmedValue = value.trim();
  return trimmedValue.length > 0 ? trimmedValue : undefined;
};

const employeeFieldsPayload = (values: EmployeeFormValues) => ({
  fullName: values.fullName.trim(),
  nationalId: values.nationalId.trim(),
  locationType: values.locationType,
  workstationId: values.workstationId,
  email: trimOptional(values.email),
  phone: trimOptional(values.phone),
  gender: values.gender === "" ? undefined : values.gender,
  department: trimOptional(values.department),
  jobTitle: trimOptional(values.jobTitle),
  seaYears: trimOptional(values.seaYears),
  landline: trimOptional(values.landline),
  nationality: trimOptional(values.nationality),
  note: trimOptional(values.note),
});

export const toCreateEmployeePayload = employeeFieldsPayload;
export const toUpdateEmployeePayload = employeeFieldsPayload;

export const toEmployeeFormValues = (employee: Employee): EmployeeFormValues => ({
  fullName: employee.fullName,
  nationalId: employee.nationalId,
  locationType: employee.locationType,
  clientCompanyId:
    employee.workstation?.clientCompanyId ?? employee.clientCompany?.id ?? "",
  workstationId: employee.workstationId ?? "",
  email: employee.email ?? "",
  phone: employee.phone ?? "",
  gender: employee.gender ?? "",
  department: employee.department ?? "",
  jobTitle: employee.jobTitle ?? "",
  seaYears: employee.seaYears ?? "",
  landline: employee.landline ?? "",
  nationality: employee.nationality ?? "",
  note: employee.note ?? "",
});
